import React, { useContext, useMemo } from "react";
import classNames from "classnames";
import styles from "./style.module.css";
import DocumentPage from "../../components/document-page";
import Button from "../../components/button";
import { useNavigate, useSearchParams } from "react-router";
import { DataContext } from "../../context/dataProvider";
import { isMobileSafari } from "../../utils/isMobileSafari";
import InstructionIos from "./ios";
import InstructionAndroid from "./android";
import InstructionWindows from "./windows";
import InstructionMacOS from "./macos";
export type DeviceType = 'ios' | 'android' | 'windows' | 'macos' | 'ubuntu';

function InstructionPage() {
  const context = useContext(DataContext);
  const navigation = useNavigate();
  const [searchParams] = useSearchParams();
  const device: string | null = searchParams.get('device');
  const mobileSafariFooterPadding = useMemo(() => isMobileSafari(), []);

  const handleClickNextPage = () => {
    navigation('/settings-end')
  }

  let accessData = 'Тариф не приобретен';
  if (context?.user?.userServer) {
    accessData = context.user.userServer.accessData;
  }

  let contentInstruction = <></>;
  if (device === 'ios') {
    contentInstruction = <InstructionIos accessData={accessData}/>;
  } else if (device === 'android') {
    contentInstruction = <InstructionAndroid accessData={accessData}/>;
  } else if (device === 'windows') {
    contentInstruction = <InstructionWindows accessData={accessData}/>;
  } else if (device === 'macos') {
    contentInstruction = <InstructionMacOS accessData={accessData}/>;
  }

  return (
    <DocumentPage variant="scrollable">
      <div className={styles.content}>{contentInstruction}</div>
      <div
        className={classNames(
          styles.footer,
          mobileSafariFooterPadding && styles.footerMobileSafari
        )}
      >
        <Button label="Готово" onClick={() => handleClickNextPage()} />
      </div>
    </DocumentPage>
  );
}

export default InstructionPage;
